const requireAll = (context) => context.keys().map(context);

// import shared project code
require('@shared-vars/index.css');
require('@lib/sharedRootCss/sharedRoot.css');
require('@lib/sharedRootCss/projectGeisingerShared.css');
require('@shared-atoms/Root/sharedRoot.css');

// import variables before atoms and molecules
require('./elements/variables/index.css');

// require the rest of the elements
requireAll(require.context('./elements/atoms/', true, /\.css$/));
requireAll(require.context('./elements/molecules/', true, /\.css$/));
requireAll(require.context('./elements/organisms/', true, /\.css$/));
